<script module>
		import HeroesCatalog from "./HeroesCatalog.svelte";
		import CreateHero from "./CreateHero.svelte";
		import DescriptSheet from "./DescriptSheet.svelte";
		import TraitsSheet from "./TraitsSheet.svelte";
		import AbilsSheet from "./AbilsSheet.svelte";
		import GearSheet from "./GearSheet.svelte";
		import CareerSheet from "./CareerSheet.svelte";

		export const heroLayouts = [
				{page: 'catalog', Page: HeroesCatalog, tab: null, label: "Katalog"},
				{page: 'create', Page: CreateHero, tab: null, label: "Erstellung"},
				{page: 'descript', Page: DescriptSheet, tab: true, label: "Beschreibung"},
				{page: 'traits', Page: TraitsSheet, tab: true, label: "Eigensch."},
				{page: 'abils', Page: AbilsSheet, tab: true, label: "Fähigkeiten"},
				{page: 'gear', Page: GearSheet, tab: true, label: "Besitztümer"},
				{page: 'career', Page: CareerSheet, tab: true, label: "Werdegang"},
			].map(layout => Object.assign(layout, {module: 'hero'}))
</script>


<script>
		import { user, view, change_attribute } from "../client.svelte.js";
		import {docs} from "../core.js";
		import {onMount} from "svelte";
		import Help from "../elements/Help.svelte";
		import Breadcrumbs from "../elements/Breadcrumbs.svelte";

		let mql = window.matchMedia("(width <= 1000px)")
		let tabs = heroLayouts.filter(layout => layout.tab)
		let Page = $derived(view.layout.Page)

		let heroes = $derived(
			user.characters.values()
				.filter(char => char.ZUB === 'Hero' && (char.owner === user.ID || user.isMaster))
				.toArray() )

		// $inspect(`HERO - section`, section)


		onMount(() => {
				if (heroes.length === 0)
						view.switch_layout('hero-creation')
				if (heroes.length <= 1 && !game.ID)		// show help when 0 or 1 hero only
						view.show_help('hero-overview')
		})

		async function select_hero(e) {
				e.stopPropagation()
				const heroID = (typeof this === 'string') ? this : e.target.value
				console.log(`HEROHEADER - Hero ${heroID} selected`)
				view.explanation = docs.find(entry => entry.topic === 'hero-manage')
				await view.select_character(heroID)
		}

		function switch_sublayout(e) {
				console.log(this)
				const layout = this.page
				view.switch_layout(layout)
		}


</script>

<!-------------------------------- HTML -------------------------------------->

<main id='manage'>

	{#if view.layout.page === 'catalog' || !view.character?.name}
		<Breadcrumbs back={view.layout.page !== 'catalog'} current="Helden verwalten" data-help="hero-manage" />
	{:else}
		<Breadcrumbs back current={view.character.name} data-help="hero-manage"
		           crumbs={[{label: "Helden verwalten", onclick: () => view.switch_layout('hero-catalog')}]} />
	{/if}

	{#if view.layout.tab}
		<nav class="sheet-tabs classical">
			{#each tabs as tab}
				<button id={tab.page} class="sheet-tab" class:active={tab.page === view.layout.page}
				        title={tab.info} onclick={() => view.switch_layout(`hero-${tab.page}`)}>
					{tab.label}
				</button>
			{/each}
		</nav>
	{/if}

	<Page disabled={game.ID || user.ID !== view.character.owner} />

	<Help/>

</main>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors
	// Have all sheets with pergament like background  https://codepen.io/readi2play/pen/LYNyEgW
	// or https://codepen.io/AgnusDei/pen/NWPbOxL

	/* same grid as the prepare module */
	#manage
		display: grid
		grid-template-columns: var(--menu-width) minmax(0, 1fr) var(--help-width, 0)
		grid-template-rows: 51px auto minmax(0, 1fr)
		grid-template-areas: "panel mnav help" "panel head help" "panel main help"

	/** tabs sitting on top of the parchment sheet (active tab shares the aged paper) **/
	.sheet-tabs
		grid-area: head
		min-height: 51px
		margin-bottom: -1px     // overlap paper border, so the active tab merges into the sheet
		padding-left: 42px
		position: relative
		z-index: 2
		display: flex
		align-items: flex-end
		gap: 4px
		min-width: 0

	.sheet-tab
		flex: 0 1 auto
		min-width: 0
		height: 38px
		margin: 0
		padding: 0 12px
		border: 1px solid colors.$grey-30
		border-bottom: none
		border-radius: 7px 7px 0 0
		background: colors.$grey-20
		color: colors.$grey-85
		font-family: var(--font-heading)
		font-weight: 600
		font-size: 16px
		white-space: nowrap
		overflow: hidden
		text-overflow: ellipsis
		cursor: pointer

		&:hover
			background: colors.$grey-30
			color: colors.$white

		&.active
			height: 45px
			padding: 0 16px
			border-color: var(--color-accent-300)
			background: var(--paper-noise) var(--paper)
			background-blend-mode: multiply
			color: var(--color-text)
			font-size: 20px
			cursor: default

	.select
		grid-area: select
		margin-left: var(--menu-width)

	header
		display: grid
		grid-template-columns: 655px 300px
		position: unset
		width: unset
		height: 200px
		overflow: hidden


	.heroSelect
		position: absolute
		top: 120px
		left: 16px
		display: flex
		gap: 1em


</style>
